var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNealCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_203_2874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.5004 46.944C10.5527 46.944 0.0565338 36.4478 0.0565338 23.5001C0.0565338 10.5523 10.5527 0.0561523 23.5004 0.0561523C36.4481 0.0561523 46.9443 10.5523 46.9443 23.5001C46.9443 36.4478 36.4481 46.944 23.5004 46.944Z",
    fill: "url(#paint0_radial_203_2874)",
    stroke: "#9E9AEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.4995 46.9435C10.5518 46.9435 0.0555573 36.4473 0.0555573 23.4996C0.0555573 10.5519 10.5518 0.0556641 23.4995 0.0556641C36.4472 0.0556641 46.9434 10.5519 46.9434 23.4996C46.9434 36.4473 36.4472 46.9435 23.4995 46.9435Z",
    fill: "url(#paint1_radial_203_2874)",
    stroke: "#9E9AEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.4507 26.2657L28.0312 23.7053L17.4577 13.1743L6.73595 23.896L17.2467 34.4696L25.4507 26.2657Z",
    fill: "url(#paint2_linear_203_2874)",
    fillOpacity: 0.74,
    stroke: "#A09BF6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0792 23.7413L40.3047 23.5146L35.8661 19.076L26.6299 9.83984H17.773L31.3714 23.5976L17.773 37.2758H26.6299L40.0803 23.7424L40.0792 23.7413Z",
    fill: "url(#paint3_linear_203_2874)",
    fillOpacity: 0.74
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M40.3055 23.5145L40.3852 23.4348L40.4648 23.5145L40.3863 23.5942L40.3066 23.5145H40.3055ZM40.3055 23.5145L40.2259 23.5942L40.1462 23.5145L40.2247 23.4348L40.3044 23.5134L40.3055 23.5145ZM40.3055 23.5145L40.3852 23.4348L40.4637 23.5145L40.3852 23.5942L40.3055 23.5145ZM35.8669 19.0759L35.7873 18.9963L35.8669 18.9166L35.9466 18.9963L35.8669 19.0759ZM35.8669 19.0759L35.9466 19.1556L35.8669 19.2353L35.7873 19.1556L35.8669 19.0759ZM26.6308 9.83974V9.72754H26.6768L26.7093 9.76008L26.6296 9.83974H26.6308ZM17.7738 9.83974L17.6941 9.91828L17.5056 9.72754H17.7738V9.83974ZM31.3723 23.5975L31.4519 23.519L31.5305 23.5987L31.4519 23.6772L31.3723 23.5975ZM17.7738 37.2757V37.3879H17.5045L17.6953 37.196L17.7749 37.2757H17.7738ZM26.6308 37.2757L26.7104 37.3542L26.6779 37.3879H26.6308V37.2757ZM40.3863 23.5953L40.1608 23.8219L40.0015 23.6637L40.227 23.4371L40.3863 23.5953ZM40.227 23.5953L35.7884 19.1567L35.9466 18.9985L40.3852 23.4371L40.227 23.5964V23.5953ZM26.7093 9.7612L35.9455 18.9974L35.7873 19.1556L26.5511 9.9194L26.7093 9.7612ZM17.7738 9.72866H26.6308V9.95306H17.7738V9.72866ZM31.2926 23.6772L17.6941 9.9194L17.8535 9.7612L31.4519 23.519L31.2926 23.6772ZM31.4519 23.6772L17.8535 37.3553L17.6941 37.1971L31.2926 23.519L31.4519 23.6772ZM17.7738 37.1635H26.6308V37.3879H17.7738V37.1635ZM26.5511 37.196L40.0015 23.6626L40.1608 23.8208L26.7104 37.3542L26.5511 37.196Z",
    fill: "#A09BF6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_203_2874",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.6861 10.4118) rotate(129.11) scale(61.4355)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504CA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3B3785"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_203_2874",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.6851 10.4113) rotate(129.11) scale(61.4355)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504CA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3B3785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_203_2874",
    x1: 17.3847,
    y1: 13.0947,
    x2: 17.3847,
    y2: 34.5493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_203_2874",
    x1: 29.0388,
    y1: 9.83984,
    x2: 29.0388,
    y2: 37.2747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_2874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "matrix(-1 0 0 1 47 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNealCoin);
export default __webpack_public_path__ + "static/media/nealCoin.388aa020971f9a42b67b6e8c348c9d38.svg";
export { ForwardRef as ReactComponent };